export const pick = (i18nObj, lang) => {
  if (!i18nObj) return "";
  return i18nObj[lang] || i18nObj.es || "";
};

export const lang2 = (lang) => (lang || "es").slice(0, 2);
